import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import moment from "moment";
import { CALL_REPORT } from "../../helpers/url_helper";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { formatDate } from "../../Components/Common/FormDateTime";
import { APIClient } from "../../helpers/api_helper";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import {
  formatToSystemTimezone,
  toCamelCase,
} from "../../Components/Common/ToCamelCase";
import SubExpired from "../../Components/Common/subExpired";
import { useLocation, useNavigate } from "react-router-dom";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import CommanDataTable from "../../Components/Common/DataTable";
import { addMonths } from "../../Components/Common/FlatePicker";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";

const api = new APIClient();

const CallLogsConsolidate = ({
  appliedFilters,
  selectedFromDate,
  selectedEmployeeOptions,
  selectedToDate,
}) => {
  document.title = "Consolidate report";
  const navigate = useNavigate();
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const { profileData } = useProfileData();
  const BooleanWithSingleEmployeeLogin =
    loginType === "employee" && permissionType.length === 0;

  const params = new URLSearchParams(window.location.search);
  const date = params.get("date"); // Retrieve the 'date' parameter

  const [isLoading, setIsLoading] = useState(false);
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);

  const [callHData, setCallHData] = useState([]);

  // callType state
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Pagination settings
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);

  //search field state
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const remainingDays = CalculateRemainingDays();

  //table data
  const column = [
    {
      name: <span className="font-weight-bold fs-13"> SN.</span>,
      width: "5%",
      selector: (row, index) => index + 1,
    },

    {
      name: <span className="font-weight-bold fs-13">Employee</span>,
      selector: (row) => toCamelCase(row?.employeeName),
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.employeeName}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.countryCode + `-` + row?.employeeNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13"> Team Name</span>,
      selector: (row, index) => row.team,
    },
    {
      name: <span className="font-weight-bold fs-13">Client Name</span>,
      selector: (row) => toCamelCase(row?.name),
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.name}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.phoneNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Date & Time</span>,
      selector: (row) => new Date(`${row?.date} ${row?.time}`).getTime(), // Timestamp for sorting
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.date}
          </h5>
          <h6 className="text-center font-weight-bold fs-13">{row?.time}</h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Call Type</span>,
      selector: (cell) => {
        switch (cell.type) {
          case "OUTGOING":
            return (
              <>
                <div style={{ textTransform: "capitalize" }}>
                  {" "}
                  <i className="mdi mdi-phone-outgoing sn-out-going-text" />{" "}
                  <span className="badge badge-soft-info sn-out-going-call">
                    {" "}
                    {cell.type}
                  </span>
                </div>
              </>
            );
          case "REJECTED":
            return (
              <>
                <i className="mdi mdi-phone-remove sn-out-rejected-text" />
                <span className="badge badge-soft-warning sn-out-rejected-call">
                  {" "}
                  {cell.type}{" "}
                </span>
              </>
            );
          case "MISSED":
            return (
              <>
                <i className="mdi mdi-phone-missed sn-out-missed-text" />
                <span className="badge badge-soft-danger sn-out-missed-call">
                  {" "}
                  {cell.type}{" "}
                </span>
              </>
            );
          case "INCOMING":
            return (
              <>
                <i className="mdi mdi-phone-incoming text-success" />
                <span className="badge badge-soft-success sn-out-incoming-call">
                  {" "}
                  {cell.type}{" "}
                </span>
              </>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.type} </span>
            );
        }
      },
      width:'200px'
    },
    {
      name: <span className="font-weight-bold fs-13">Call Recording </span>,
      width: "37%",
      selector: (row) => (
        <>
          {row?.recording ? (
            <div
              style={{
                display: "inline-grid",
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              <span style={{ height: "10px" }}>{row?.duration}</span>
              <audio
                style={{ height: "40px", marginTop: "15px" }}
                src={row?.recording}
                controls
              />
            </div>
          ) : row?.duration && row.duration !== "00:00:00" ? (
            <div
              style={{
                display: "inline-grid",
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              {["OUTGOING", "INCOMING", "REJECTED", "MISSED"].includes(
                row.type
              ) ? (
                <>
                  <span style={{ height: "10px" }}>{row?.duration}</span>
                  <span style={{ marginTop: "10px", color: "warning" }}>
                    Recording sync in progress...
                  </span>
                </>
              ) : (
                "Call Not Connected"
              )}
            </div>
          ) : (
            "Call Not Connected"
          )}
        </>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13" style={{ textAlign: "left" }}>
          Notes
        </span>
      ),
      selector: (row) => row.notes,
      sortable: true,
      cell: (row) => (
        <div style={{ textAlign: "left", width: "100%" }}>{row.notes}</div>
      ),
    },
  ];

  // this use Effect is only run in the condition where the (loginType === "employee") && (permissionType.length === 0)
  useEffect(() => {
    if (BooleanWithSingleEmployeeLogin) {
      callHistoryData(currentPage, perPage, profileData._id);
    }
  }, [profileData, appliedFilters]);

  // Debounce search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
      setCurrentPage(1);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // Fetch data when debounced query, currentPage, or perPage changes
  const fetchData = async () => {
    if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
      try {
        let defaultId =
          selectedEmployeeOptions?.map((option) => option?.id) || []; // EmployeeData

        if (selectedEmployeeOptions.length === 0) {
          defaultId = [];
        }
        await callHistoryData(
          currentPage,
          perPage,
          defaultId,
          "",
          debouncedQuery
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    const updatedIds =
      selectedEmployeeOptions?.map((userid) => userid?.id) || [];

    // Build IDs based on login type
    let defaultId = [];
    let idsForMulti = updatedIds;

    if (BooleanWithSingleEmployeeLogin) {
      if (!profileData?._id) return; // wait until profile is ready to avoid double call
      defaultId = [profileData._id];
      idsForMulti = [];
    }
    // Only fetch when search length is 0 or >= 3
    if (debouncedQuery.length === 0 || debouncedQuery.length >= 3) {
      callHistoryData(currentPage,perPage,defaultId,idsForMulti,debouncedQuery);
    }
  }, [debouncedQuery, currentPage, perPage, appliedFilters]);

   // Search field handler
  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const callHistoryData = async (
    page,
    size = perPage,
    defaultId,
    updatedIds,
    searchTerm = ""
  ) => {
    setIsLoading(true);
    try {
      const callTy = selectedOptions?.map((option) => option?.value) || [];
      let data = {};
      const id = appliedFilters?.employees.map((userid) => userid?.id);
      if (defaultId.length > 0) {
        data = {
          startDate: appliedFilters
            ? formatDate(appliedFilters.fromDate)
            : formatDate(selectedFromDate),
          endDate: appliedFilters
            ? formatDate(appliedFilters.toDate)
            : formatDate(selectedToDate),
          startTime: "00:00",
          endTime: "23:59",
          callType: callTy,
          employeeIds: id ? id : defaultId,
        };
      } else {
        data = {
          startDate: appliedFilters
            ? formatDate(appliedFilters.fromDate)
            : formatDate(selectedFromDate),
          endDate: appliedFilters
            ? formatDate(appliedFilters.toDate)
            : formatDate(selectedToDate),
          startTime: "00:00",
          endTime: "23:59",
          callType: callTy,
          employeeIds: id ? id : updatedIds,
        };
      }
      const response = await api.create(
        `${CALL_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`,
        data
      );
      setIsLoading(false);

      if (response && response.success === true) {
        const apiResponse = response.data;
        let tableData = (apiResponse?.paginatedResults || [])?.map(
          (item, index) => {
            const recordingUserStatus = item.recordingStatus?.replace(
              /_/g,
              " "
            );
            const dateTimeString = item.dateTime;
            const systemDateTimeString = formatToSystemTimezone(dateTimeString);
            return {
              employeeName: Array.isArray(item?.employeeDescription)
                ? item.employeeDescription[0]?.fullName
                : "unknown",
              employeeNumber: Array.isArray(item?.employeeDescription)
                ? item.employeeDescription[0]?.mobileNumber
                : "-",
              name: item?.name || "unknown",
              phoneNumber: item?.phoneNumber || "-",
              date: dateTimeString
                ? moment(dateTimeString).format("DD MMM YYYY")
                : "-",
              time: systemDateTimeString || "-",
              duration: new Date(item.duration * 1000)
                .toISOString()
                .slice(11, 19),
              type: item?.type || "-",
              notes: item?.note || "-",
              status: recordingUserStatus || "-",
              recording: item?.callRecording,
              countryCode: item?.employeeDescription[0].countryCode,
              team:item?.employeeDescription[0]?.team[0]|| 'No Team'
            };
          }
        );
        setCallHData(tableData);
        setTotalRows(apiResponse.totalCount);
      }
    } catch (error) {
      if (!remainingDays === 0) {
        HandleErrorMessage(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setIsExpiredModalOpen(false);
    navigate("/planPackage");
  };

  return (
    <React.Fragment>
      {remainingDays === 0 && isExpiredModalOpen && (
        <SubExpired
          onClose={handleClose}
          profileData={profileData?.selectedPlanDetails?.planName}
          remainingDays={remainingDays}
        />
      )}
      <div className=" sn-call-report-page-top ">
        <Container fluid>

          <Card className="h-100  ">
            <CardBody>
              <Row className="sn-user-tble-manin-manage ">
                <Col lg={12}>
                  <div className="sn-call-logs-report-tble-common-isuee search-datatable-wrapper">
                    <CommanDataTable
                      perPage={perPage}
                      setCurrentPage={setCurrentPage}
                      column={column}
                      tableData={callHData}
                      handleSearch={handleSearch}
                      searchText={query}
                      handlePerRowsChange={handlePerRowsChange}
                      totalRows={totalRows}
                      currentPage={currentPage}
                      isLoading={isLoading}
                      handlePageChange={handlePageChange}
                      noData="There are no records to display"
                      inputClass={
                        (callHData && callHData.length > 0) || query
                          ? "d-block mb-4"
                          : "d-none"
                      }
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CallLogsConsolidate;
